import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { KindService } from 'app/services/models/kind.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-kind',
  templateUrl: './create-kind.component.html',
  styleUrls: ['./create-kind.component.scss']
})
export class CreateKindComponent implements OnInit {
  kindForm: FormGroup;
  @Input() kind: any;
  isEditMode = false;
  constructor(
    private formBuilder: FormBuilder,
    private _coreSidebarService: CoreSidebarService,
    private kindService: KindService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    console.log(this.kind);
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Check if 'kind' input has changed and if it is not null or undefined
    if (changes['kind'] && this.kind) {
      // Ensure the form is initialized before calling reset
      if (this.kindForm) {
        this.kindForm.reset();
      }
      this.isEditMode = true;
      // Update the form with the new values from 'kind'
      this.kindForm.patchValue({
        kindName: this.kind.typeName || '',
        kindNumber: this.kind.typeNumber || null
      });
    }
  }

  initializeForm() {
    this.kindForm = this.formBuilder.group({
      kindName: ['', [Validators.required, Validators.maxLength(25)]],
      kindNumber: [null, [Validators.required, Validators.min(1), Validators.max(99999)]]
    });
  }

  toggleSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  async onSubmit() {
    if (this.kindForm.valid) {
      const kindName = this.kindForm.get('kindName').value;
      const kindNumber = this.kindForm.get('kindNumber').value;

      let data;
      console.log(this.isEditMode)
      if (this.isEditMode) {
        data = await this.kindService.updateKind(this.kind.id, kindName, kindNumber);
      } else {
        data = await this.kindService.createKind(kindName, kindNumber);
      }

      if (data.status == true) {
        this.kindService.sendEvent(true);
        this.toastrService.success(data.message, 'Başarılı');
      } else {
        this.toastrService.error(data.message, 'Başarısız');
      }

      this.toggleSidebar('create-kind');
    }
  }
}
